/**
 * Formats a numeric badge count, clamping to `${max}+` once it exceeds `max`.
 * Single source of truth shared by `CountBadge` and its spec.
 */
export const formatCount = (count: number, max: number): string =>
    count > max ? `${max}+` : String(count)
